package com.daytimegaming.ourdailyfinances.presentation.auth

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.daytimegaming.ourdailyfinances.domain.usecase.UserUseCase
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

data class UpdateUserInfoState(
    val email: String = "",
    val firstName: String = "",
    val lastName: String = "",
    val isLoading: Boolean = false,
    val error: String? = null,
    val isSuccess: Boolean = false,
)

class UpdateUserInfoViewModel(
    private val userUseCase: UserUseCase,
) : ViewModel() {

    private val _state = MutableStateFlow(UpdateUserInfoState())
    val state = _state.asStateFlow()

    fun setEmail(email: String) {
        _state.update { it.copy(email = email) }
    }

    fun onFirstNameChange(firstName: String) {
        _state.update { it.copy(firstName = firstName) }
    }

    fun onLastNameChange(lastName: String) {
        _state.update { it.copy(lastName = lastName) }
    }

    fun updateInfo(onSuccess: () -> Unit) {
        val currentState = _state.value
        if (currentState.firstName.isBlank() || currentState.lastName.isBlank()) {
            _state.update { it.copy(error = "All fields must be entered") }
            return
        }

        viewModelScope.launch {
            _state.update { it.copy(isLoading = true, error = null) }
            try {
                userUseCase.UpdateUserProfile(
                    firstName = currentState.firstName,
                    lastName = currentState.lastName,
                )
                _state.update { it.copy(isLoading = false, isSuccess = true) }
                onSuccess()
            } catch (e: Exception) {
                _state.update { it.copy(isLoading = false, error = formatAuthErrorMessage(e.message, defaultMessage = "Failed to update info")) }
            }
        }
    }
}
